import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

const useCartItemChecker = (hisId) => {
  const router = useRouter();
  const [isCartItemAdded, setIsCartItemAdded] = useState(false);
  const cartInfo = useSelector((state) => state?.homecare?.hcCartInfo?.cartInfo);

  useEffect(() => {
    if (Object.keys(cartInfo).length > 0) {
      cartInfo?.items?.forEach((item) => {
        if (hisId === item?.productId) {
          setIsCartItemAdded(true);
        }
      });
    } else {
      setIsCartItemAdded(false);
    }

    return () => {
      setIsCartItemAdded(false);
    };
  }, [cartInfo?.items?.length, router?.query?.id]);

  return isCartItemAdded;
};
export default useCartItemChecker;
